export const CopyOnClick = {
  mounted() {
    this.resizeObserver = new ResizeObserver(() => this.syncShowIfTruncated());
    this.resizeObserver.observe(this.el);

    this.el.addEventListener("click", (ev) => {
      ev.preventDefault();
      const local_id = this.el.id;

      let textToCopy;
      if (this.el.dataset.copyOnClickText) {
        textToCopy = this.el.dataset.copyOnClickText;
      } else {
        textToCopy = document
          .querySelector(`#value-${local_id}`)
          .innerText.trim();
      }

      navigator.clipboard.writeText(textToCopy);

      const tooltip = document.querySelector(`#tooltip-${local_id}`);
      tooltip.classList.remove("hidden");
      if (this.el.dataset.animation == "false") {
        tooltip.classList.add("opacity-100");
      } else {
        tooltip.classList.add("brief-appearance-animation");
      }

      let tooltipHover = document.querySelector(`#tooltip-${local_id}_hover`);
      tooltipHover.classList.remove("block");
      tooltipHover.classList.add("hidden");
      tooltipHover.classList.remove("group-hover:opacity-100");
      tooltipHover.classList.remove("group-hover:block");

      setTimeout(() => {
        if (this.el.dataset.animation == "true") {
          tooltip.classList.remove("brief-appearance-animation");
        }
        tooltip.classList.add("hidden");

        tooltipHover.classList.add("group-hover:opacity-100");
        tooltipHover.classList.add("group-hover:block");
      }, 2000);
    });
  },

  updated() {
    this.syncShowIfTruncated();
  },

  destroyed() {
    this.resizeObserver?.disconnect();
  },

  // Re-queried on every call: the ids are regenerated on each render, so LiveView
  // replaces these nodes rather than patching them, and any cached ref goes stale.
  syncShowIfTruncated() {
    const showIfTruncatedEl = this.el.querySelector("[data-show-if-truncated]");
    const label = this.el.querySelector(`[id^="value-"]`);
    if (!showIfTruncatedEl || !label) return;

    showIfTruncatedEl.classList.toggle(
      "hidden",
      label.scrollWidth <= label.clientWidth,
    );
  },
};
